<template>
    <div>
        <v-card v-if="successMessage" color="primary" @input="onSuccessMessageStateChange" flat>
            <v-card-title class="white--text subheading">
                {{ successMessage }}

                <v-spacer/>

                <v-btn icon @click="$emit('input', false)">
                    <v-icon color="white">close</v-icon>
                </v-btn>
            </v-card-title>
        </v-card>

        <v-sheet class="py-3 px-0">
            <basket-items
                floating
                :items="items"
                displayFreeShippingInfo
                no-totals
                hide-tier-price-info
                flat-cards
                :related-products-cols="1"
                prevent-load-products
            >
                <template v-slot:afterItems>
                    <v-sheet class="px-3 pb-3 text-xs-right">
                        <v-btn :to="{name: 'basket'}" @click.native="onBtnClick">
                            {{ 'To the basket of goods' | translation }}
                        </v-btn>

                        <v-btn
                            class="mr-0"
                            color="primary"
                            :to="checkoutStepData"
                            @click.native="onBtnClick"
                        >
                            {{ 'Proceed to checkout' | translation }}
                        </v-btn>
                    </v-sheet>
                </template>
            </basket-items>
        </v-sheet>

        <cheaper-bulk-price
            v-if="cheaperBuilkPriceProduct !== null"
            :basketItem="cheaperBuilkPriceProduct.basketItem"
            :basketProduct="cheaperBuilkPriceProduct.basketProduct"
            :missingQuantity="cheaperBuilkPriceProduct.missingQuantity"
        />

        <upgrades-products :basket-items-product-ids="upgradesProducts"/>

        <related-products :productIds="relatedProducts"/>
    </div>
</template>

<script>
import RelatedProducts from '@breakmedia/prime-vue-product/src/RelatedProducts';
import {mapState, mapMutations} from 'vuex';
import UpgradesProducts from '../UpgradesProducts';
import CheaperBulkPrice from '../CheaperBulkPrice';

export default {
    components: {
        RelatedProducts,
        UpgradesProducts,
        CheaperBulkPrice,
    },
    data() {
        return {
            maxCrosssellsProductsDisplay: 2,
            maxUpgradesProductsDisplay: 2,
            cheaperBuilkPriceProduct: null,
        };
    },
    destroyed() {
        this.setSuccessMessage(null);
        this.$basket.resetLatestItems();
    },
    computed: {
        ...mapState('FloatingBasket', [
            'successMessage',
        ]),
        ...mapState('Basket', {
            products: state => state.products,
        }),
        ...mapState('Customer', ['customerHasDSGVO']),
        checkoutStepData() {
            return {
                name: 'checkout',
                params: {
                    stepName: this.customerHasDSGVO ? 'summary' : 'address',
                }
            };
        },
        getLastBasketChange() {
            return this.$basket.getLastBasketChange();
        },
        items() {
            const items = this.$basket.getLatestAddedItems();
            for (const hash in items) {
                return {
                    [hash]: items[hash]
                }
            }
        },
        relatedProducts() {
            let result = [];

            label:
                for (let basketItem of Object.values(this.$basket.getLatestAddedItems())) {
                    let product = this.products ? this.products[basketItem.product_id] : {};
                    if (product && product.crosssells && product.crosssells.length) {
                        for (let crosssell of product.crosssells) {
                            if (result.length < this.maxCrosssellsProductsDisplay) {
                                result.push(crosssell);
                            } else {
                                break label;
                            }
                        }
                    }
                }

            return result;
        },
        upgradesProducts() {
            let result = {};
            let itemsCount = 0;

            label:
                for (let basketItem of Object.values(this.$basket.getLatestAddedItems())) {
                    let product = this.products ? this.products[basketItem.product_id] : {};
                    if (product && product.upgrades && product.upgrades.length) {
                        for (let upgrade of product.upgrades) {
                            if (itemsCount < this.maxUpgradesProductsDisplay) {
                                if (result[basketItem.hash] === undefined) {
                                    result[basketItem.hash] = [];
                                }

                                result[basketItem.hash].push(upgrade);

                                itemsCount++;
                            } else {
                                break label;
                            }
                        }
                    }
                }

            return result;
        },
    },
    methods: {
        ...mapMutations('FloatingBasket', [
            'setSuccessMessage',
            'setShowFloatingBasket',
        ]),
        onSuccessMessageStateChange(value) {
            if (!value) {
                this.setSuccessMessage(null);
            }
        },
        onBtnClick() {
            this.setShowFloatingBasket(false);
            this.$nextTick(() => {
                this.$emit('input', false);
            });
        }
    },
    watch: {
        getLastBasketChange() {
            this.cheaperBuilkPriceProduct = null;
            const basketItem = this.$basket.getBasketItem(Object.keys(this.$basket.getLatestAddedItems()).shift());
            const basketProduct = this.products.hasOwnProperty(basketItem.product_id)
                ? this.products[basketItem.product_id]
                : null;
            if (basketProduct) {
                const merchantId = basketItem.options.merchant;
                if (
                    basketProduct.merchant.hasOwnProperty(merchantId) &&
                    basketProduct.merchant[merchantId].hasOwnProperty('tierPrice')
                ) {
                    const currentQuantity = basketItem.quantity;
                    let missingQuantity = 0;
                    if (
                        basketProduct.merchant[merchantId].tierPrice &&
                        basketProduct.merchant[merchantId].tierPrice[basketItem.catalog_item_id]
                    ) {
                        basketProduct.merchant[merchantId].tierPrice[basketItem.catalog_item_id]
                            .sort((a, b) => a - b)
                            .some((quantity) => {
                                if (currentQuantity < quantity) {
                                    missingQuantity = quantity - currentQuantity;
                                }
                                return missingQuantity > 0;
                            });
                    }
                    if (missingQuantity > 0) {
                        this.cheaperBuilkPriceProduct = {
                            basketItem,
                            missingQuantity,
                            basketProduct,
                        };
                    }
                }
            }
        },
    }
};
</script>